import { jsx, jsxs } from "react/jsx-runtime";
import { Public, ChevronUpSmall, ChevronDownSmall } from "@wix/wix-ui-icons-common/on-stage";
import { IconButton } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { forwardRef } from "react";
import { useTranslation } from "../../../../contexts/translation-context.js";
import { Flag } from "../flag.js";
import { classes } from "./flag-button.st.css";
const FlagButton = forwardRef(
  ({ arrowDirection, longCountryCode, onClick, readOnly, ariaLabel }, ref) => {
    const { t } = useTranslation();
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        className: classes.root,
        "data-hook": "country-selector-trigger",
        "aria-label": `${ariaLabel}. ${t(
          "field.phone.country-selector-button.aria-label"
        )}`,
        innerRef: ref,
        onClick,
        icon: /* @__PURE__ */ jsxs("div", { className: classes.flagButton, children: [
          longCountryCode ? /* @__PURE__ */ jsx("div", { className: classes.flag, children: /* @__PURE__ */ jsx(Flag, { longCountryCode }) }) : /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(classes.noFlag, {
                [classes.readOnly]: readOnly
              }),
              children: /* @__PURE__ */ jsx(Public, {})
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(classes.arrow, {
                [classes.readOnly]: readOnly
              }),
              children: arrowDirection === "up" ? /* @__PURE__ */ jsx(ChevronUpSmall, {}) : /* @__PURE__ */ jsx(ChevronDownSmall, {})
            }
          )
        ] })
      }
    );
  }
);
export {
  FlagButton
};
//# sourceMappingURL=flag-button.js.map
